import { Box, SxProps, Theme, Typography } from "@mui/material";
import { ReactNode } from "react";
import BroadsheetLink from "@/src/components/common/broadsheet/link";
import {
  FONT_DISPLAY,
  FONT_UI,
  hairline,
  HEADING_SIZE,
} from "@/src/components/common/broadsheet/tokens";

export default function SectionHeading({
  title,
  titleId,
  deck,
  action,
  component = "h2",
  size = "section",
  rule = true,
  sx,
}: {
  title: ReactNode;
  titleId?: string;
  deck?: ReactNode;
  action?: { label: string; href: string };
  component?: "h1" | "h2" | "h3" | "h4";
  size?: "page" | "section";
  rule?: boolean;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      sx={[
        {
          display: "flex",
          flexWrap: "wrap",
          alignItems: "baseline",
          justifyContent: "space-between",
          columnGap: 1,
          rowGap: 0.25,
          pb: rule ? 0.5 : 0,
          ...(rule ? hairline : null),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography
          component={component}
          id={titleId}
          sx={{
            fontFamily: FONT_DISPLAY,
            fontWeight: 700,
            fontSize: HEADING_SIZE[size],
            lineHeight: 1.15,
            letterSpacing: "0.01em",
            color: "custom.ink",
            m: 0,
          }}
        >
          {title}
        </Typography>
        {deck ? (
          <Typography
            component="p"
            sx={{
              fontFamily: FONT_UI,
              fontSize: "0.8125rem",
              lineHeight: 1.5,
              color: "custom.inkMuted",
              m: 0,
              mt: 0.25,
              maxWidth: "60ch",
            }}
          >
            {deck}
          </Typography>
        ) : null}
      </Box>
      {action ? (
        <BroadsheetLink
          href={action.href}
          sx={{
            fontFamily: FONT_UI,
            fontSize: "0.75rem",
            fontWeight: 600,
            color: "custom.link",
            textDecoration: "none",
            flex: "none",
            paddingBlock: "0.4rem",
            "&:hover": {
              color: "custom.linkHover",
              textDecoration: "underline",
            },
          }}
        >
          {action.label} →
        </BroadsheetLink>
      ) : null}
    </Box>
  );
}
